export default __webpack_public_path__ + "static/media/SideTable_Terracotta_Desktop.e2443968.png";